module.exports = __webpack_public_path__ + "img/ic_32_profile_premium.86e5d4ca.svg";